import { useEffect, useState, useRef, useLayoutEffect } from 'react'
import { useToast } from 'uxp/components'
import { IContextProvider } from '../../uxp'

const IMAGES_PER_PAGE = 50

export default function useImageSearch(query: string, pageNumber: number, uxpContext: IContextProvider, visibilityOfParentDialog: boolean = true, unplashQueryParameters = {}) {
    const [loading, setLoading] = useState<boolean>(true)
    const [error, setError] = useState<boolean>(false)
    const [photos, setPhotos] = useState([])
    const [hasMore, setHasMore] = useState<boolean>(false)

    const toast = useToast()

    useEffect(() => {
        if(query == '') setLoading(false)
        setPhotos([])
    }, [query])

    const hasChangedQuery = useRef<boolean>(false);

    useEffect(() => {
        hasChangedQuery.current = false
        setPhotos([])
    }, [visibilityOfParentDialog])

    useLayoutEffect(() => {
        if(!visibilityOfParentDialog) return

        setError(false)

        if (!!hasChangedQuery.current && query?.trim() == '') {
            setPhotos([]);
            return;
        }

        if (!hasChangedQuery.current) hasChangedQuery.current = true;

        const params = {
            ...unplashQueryParameters,
            query: query,
            page: pageNumber,
            per_page: IMAGES_PER_PAGE,
        }

        setLoading(true)

        uxpContext
            .executeService('Lucy', 'SearchImagesFromUnsplash', params, { json: true })
            .then(res => {
                const data = JSON.parse(res?.[0].data)
                const newPhotos = data?.results || data

                setPhotos(prevPhotos => {
                    return [...new Set([...prevPhotos, ...newPhotos])]
                })

                setHasMore(data?.total_pages ? data?.total_pages > pageNumber :  false)
                setLoading(false)
            })
            .catch(e => {
                console.error(e);
                toast.error("Error in retrieving images...")
            })
            .finally(() => {
                setLoading(false)
            })
    }, [query, pageNumber, visibilityOfParentDialog])

    return { loading, error, photos, hasMore }
}